import * as React from 'react';

const MenuHome = () => (
  <svg
    width={32}
    height={24}
    viewBox="0 0 32 24"
    stroke="none"
    strokeWidth={1}
    fill="#FFFFFF"
    fillRule="evenodd">
    <path d="M19.5,17 L19.5,18 L17,18 L17,20.5 L16,20.5 L16,18 L13.283,18 L13.283,17 L16,17 L16,14.5 L17,14.5 L17,17 L19.5,17 Z M10,12.398 L20.81,3.734 L31.5,12.458 L31.5,24 L28.5,24 L28.5,18.033 C28.5,17.624 28.077,17 27.663,17 L23.447,17 C23.033,17 22.5,17.624 22.5,18.033 L22.5,24 L10,24 L10,12.398 Z M19.5,19.704 L19.5,15.196 C19.5,14.787 19.158,14.5 18.743,14.5 L14,14.5 C13.586,14.5 13.283,14.787 13.283,15.196 L13.283,19.704 C13.283,20.113 13.586,20.5 14,20.5 L18.743,20.5 C19.158,20.5 19.5,20.113 19.5,19.704 Z" />
    <path d="M9.5,9.021 L20.81,0 L32,8.848 L32,11.184 L21.277,2.705 C21.14,2.597 20.974,2.543 20.808,2.543 C20.642,2.543 20.476,2.597 20.339,2.706 L9.5,11.124 L9.5,9.021 Z" />
    <path
      fill="#667AC3"
      d="M8,12.671 L8,8.437 C8,8.297 6.462,3.333 5.553,3.333 C3.129,3.333 0,17.72 0,20.724 C0,22.35 1.83,23.741 4.5,23.965 L4.5,20.94 L2.906,19.621 C2.568,19.386 2.486,18.924 2.724,18.589 C2.962,18.254 3.43,18.174 3.768,18.409 L4.5,19.128 L4.5,13.428 C4.5,13.019 4.836,12.687 5.25,12.687 C5.664,12.687 6,13.019 6,13.428 L6,23.965 C7.024,23.879 7.724,23.624 8.5,23.247 L8.5,13.406 C8.377,13.412 8,12.956 8,12.671 Z"
    />
  </svg>
);

export default MenuHome;



// WEBPACK FOOTER //
// ./src/assets/images/icons/menu-home.js